<template>
  <div class="card bg-base-200 overflow-hidden shadow-sm">
    <div class="flex flex-col items-center gap-2 p-2">
      <div
        class="bg-base-300 flex aspect-square w-full items-center justify-center rounded-lg"
      >
        <img :src="url" class="h-full w-full rounded-lg object-cover" />
      </div>
      <div class="text-center">
        <div class="w-full max-w-37.5 truncate text-sm font-medium">
          Ảnh chụp màn hình
        </div>
        <div class="text-xs opacity-60">
          {{ dayjs(created_at).format("DD/MM/YYYY HH:mm:ss") }}
        </div>
      </div>
      <button
        class="btn btn-ghost btn-xs btn-primary mt-1"
        @click.stop="download"
      >
        <i class="fa-solid fa-download mr-1"></i> Tải xuống
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from "dayjs";

const props = defineProps<{
  created_at: number;
  url: string;
}>();

const download = () => {
  const link = document.createElement("a");
  link.href = props.url;
  link.setAttribute("download", props.url.split("/").pop() || "screenshot");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
</script>
